var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/dc2d11aecd251a06fadfc08779448d8d.js').default;export default
        Object.assign({}, scope_0 )
    